import { render } from "./NoticiasView.vue?vue&type=template&id=03dd7722"
import script from "./NoticiasView.vue?vue&type=script&lang=js"
export * from "./NoticiasView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__